if (!window.nekoanProductLayoutBound) {
  window.nekoanProductLayoutBound = true;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-nekoan-open-size]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.nekoanOpenSize);
      if (dialog && !dialog.open) {
        dialog.nekoanOpener = opener;
        dialog.showModal();
        document.documentElement.classList.add('nekoan-size-open');
      }
    }
    const closer = event.target.closest('[data-nekoan-close-size]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.nekoan-size-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('.nekoan-size-dialog')) {
      document.documentElement.classList.remove('nekoan-size-open');
      event.target.nekoanOpener?.focus();
    }
  }, true);
}


// Move existing image nodes between the sixth gallery slot and the detail grid.
// A variant changes the viewing state only; Shopify media and associations stay intact.
(() => {
  const states = new WeakMap();
  const changedAttributes = ['data-nekoan-source-media', 'data-nekoan-full-url', 'data-nekoan-thumb-url', 'data-nekoan-detail-media', 'data-media-id', 'href', 'data-zoom-image', 'data-image', 'hidden'];
  const snapshot = (node) => node ? [node, Array.from(node.attributes).filter(a => node.tagName === 'IMG' || changedAttributes.includes(a.name)).map(a => [a.name, a.value])] : null;
  const restoreAttributes = (entry) => {
    if (!entry) return;
    const [node, attrs] = entry;
    Array.from(node.attributes).filter(a => node.tagName === 'IMG' || changedAttributes.includes(a.name)).forEach(a => node.removeAttribute(a.name));
    attrs.forEach(([name, value]) => node.setAttribute(name, value));
  };
  const loadImage = image => {
    if (!image.getAttribute('src')) image.setAttribute('src', image.dataset.src || '');
    if (!image.getAttribute('srcset') && image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
    image.classList.remove('lazyload', 'lazyloading');
    image.classList.add('lazyloaded');
  };
  window.nekoanSelectMedia = (section, variant) => {
    const gallery = section.querySelector('[data-nekoan-split-gallery]');
    const detailSection = document.querySelector(`[data-nekoan-detail-section][data-product-id="${section.dataset.productId}"]`);
    const state = states.get(gallery);
    if (state) {
      state.upperParent.replaceChild(state.upperImage, state.lowerImage);
      state.lowerParent.append(state.lowerImage);
      state.marker.replaceWith(state.figure);
      state.snapshots.forEach(restoreAttributes);
      state.loaders.forEach(([node, hidden]) => { node.hidden = hidden; });
      states.delete(gallery);
    }
    const mediaId = String(variant.featured_media.id);
    const guide = document.getElementById(`nekoan-size-${section.dataset.productId}`);
    const featuredUrl = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
    if (featuredUrl && Array.from(guide?.querySelectorAll('.nekoan-chart-image') || []).some(link => new URL(link.href).pathname === new URL(featuredUrl, location.href).pathname)) return true;
    const target = detailSection?.querySelector(`[data-nekoan-detail-media="${mediaId}"]`);
    // Existing upper-gallery media continue through the theme's native selector.
    if (!target) return false;
    const slides = Array.from(gallery.querySelectorAll('.productView-image:not(.slick-cloned)'));
    const imageSlides = slides.filter(slide => slide.querySelector('img[data-main-image]'));
    const slot = imageSlides[5];
    const upperImage = slot?.querySelector('img[data-main-image]');
    const lowerImage = target.querySelector('img');
    if (!upperImage || !lowerImage) return false;
    const upperParent = upperImage.parentElement;
    const lowerParent = lowerImage.parentElement;
    const media = slot.querySelector('.product-single__media');
    const oldId = media.dataset.mediaId;
    const thumbs = Array.from(section.querySelectorAll(`.productView-thumbnail[data-media-id="${section.id.replace('ProductSection-', '')}-${oldId}"]`));
    const snapshots = [slot, media, upperParent, lowerParent, target, upperImage, lowerImage,
      ...thumbs.flatMap(t => [t, t.querySelector('img'), t.querySelector('[data-image]')])].map(snapshot).filter(Boolean);
    const marker = document.createComment('nekoan-detail-position');
    target.before(marker);
    target.parentElement.prepend(target);
    const oldFull = slot.dataset.nekoanFullUrl;
    const oldThumb = slot.dataset.nekoanThumbUrl;
    // A size chart temporarily swapped out of the sixth slot belongs only in Size Guide.
    target.hidden = Array.from(guide?.querySelectorAll('.nekoan-chart-image') || []).some(link => link.href === new URL(oldFull, location.href).href);
    upperParent.replaceChild(lowerImage, upperImage);
    lowerParent.append(upperImage);
    media.dataset.mediaId = mediaId;
    slot.dataset.nekoanSourceMedia = mediaId;
    slot.dataset.nekoanFullUrl = target.dataset.nekoanFullUrl;
    slot.dataset.nekoanThumbUrl = target.dataset.nekoanThumbUrl;
    upperParent.setAttribute('href', target.dataset.nekoanFullUrl);
    if (upperParent.hasAttribute('data-zoom-image')) upperParent.dataset.zoomImage = target.dataset.nekoanFullUrl;
    target.dataset.nekoanDetailMedia = oldId;
    target.dataset.nekoanFullUrl = oldFull;
    target.dataset.nekoanThumbUrl = oldThumb;
    lowerParent.setAttribute('href', oldFull);
    lowerImage.setAttribute('data-main-image', '');
    lowerImage.dataset.index = upperImage.dataset.index;
    lowerImage.setAttribute('sizes', upperImage.getAttribute('sizes'));
    lowerImage.setAttribute('loading', 'eager');
    upperImage.removeAttribute('data-main-image');
    upperImage.removeAttribute('data-index');
    upperImage.setAttribute('loading', 'lazy');
    upperImage.setAttribute('sizes', '(min-width: 1200px) 574px, (min-width: 750px) calc((100vw - 52px) / 2), calc(100vw - 32px)');
    loadImage(upperImage);
    loadImage(lowerImage);
    const loaders = Array.from(slot.querySelectorAll('.data-lazy-loading'), node => [node, node.hidden]);
    loaders.forEach(([node]) => { node.hidden = true; });
    thumbs.forEach(thumb => {
      thumb.dataset.mediaId = `${section.id.replace('ProductSection-', '')}-${mediaId}`;
      const img = thumb.querySelector('img');
      if (img) {
        img.setAttribute('src', slot.dataset.nekoanThumbUrl);
        img.setAttribute('srcset', slot.dataset.nekoanThumbUrl);
        img.setAttribute('data-src', slot.dataset.nekoanThumbUrl);
        img.setAttribute('data-srcset', slot.dataset.nekoanThumbUrl);
        img.setAttribute('alt', lowerImage.alt);
      }
      const link = thumb.querySelector('[data-image]');
      if (link) link.dataset.image = slot.dataset.nekoanFullUrl;
    });
    states.set(gallery, {upperImage, lowerImage, upperParent, lowerParent, figure: target, marker, snapshots, loaders});
    const go = () => {
      if (!gallery.slick || gallery.slick.unslicked) return;
      window.jQuery(gallery).slick('slickGoTo', slides.indexOf(slot));
    };
    if (window.jQuery) {
      if (gallery.slick) go();
      else window.jQuery(gallery).one('init.nekoanVariantMedia', () => queueMicrotask(go));
    }
    return true;
  };
})();

(() => {
  const defaults = new WeakMap();
  const configure = (gallery, instance) => {
    const $ = window.jQuery;
    if (!$ || !gallery.classList.contains('slick-initialized')) return;
    const slick = instance || gallery.slick;
    if (!slick) return;
    if (!defaults.has(gallery)) defaults.set(gallery, {touchThreshold: slick.options.touchThreshold, speed: slick.options.speed, waitForAnimate: slick.options.waitForAnimate, adaptiveHeight: slick.options.adaptiveHeight});
    Object.assign(slick.options, defaults.get(gallery), {speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250, waitForAnimate: false});
    if (matchMedia('(max-width: 767px)').matches) {slick.options.touchThreshold = 12;slick.options.adaptiveHeight = false;}
    requestAnimationFrame(() => {if(!slick.unslicked) slick.setPosition();});
  };
  const configureAll = () => document.querySelectorAll('[data-nekoan-split-gallery]').forEach(gallery => configure(gallery));
  if (window.jQuery) window.jQuery(document).on('init.nekoanTouch reInit.nekoanTouch breakpoint.nekoanTouch', '[data-nekoan-split-gallery]', function (event, slick) { configure(this, slick); });
  document.addEventListener('DOMContentLoaded', configureAll);
  window.addEventListener('load', configureAll, {once: true});
  matchMedia('(max-width: 767px)').addEventListener('change', configureAll);
  configureAll();
})();
